import { api } from 'app/config/apiConfig';
import { ContractItemPriceRaise } from '../model/types';

export const sendPriceRaiseNotificationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    sendPriceRaiseNotification: builder.mutation<ContractItemPriceRaise, string>({
      query: (contractItemPriceRaiseId) => ({
        url: `/contracts/price-raises/${contractItemPriceRaiseId}/notify`,
        method: 'POST',
      }),
      invalidatesTags: ['Contracts', 'Contract item price raises'],
    }),
  }),
});

export const { useSendPriceRaiseNotificationMutation } = sendPriceRaiseNotificationApi;
